const initialState = () => ({
  isNewVersionAvailable: false,
  alertMessage: ''
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_NEW_VERSION_AVAILABLE (state, isNewVersionAvailable = true) {
    state.isNewVersionAvailable = !!isNewVersionAvailable
  },
  SET_ALERT_MESSAGE (state, message) {
    state.alertMessage = message
  }
}

export const getters = {
  isNewVersionAvailable: state => state.isNewVersionAvailable,
  alertMessage: state => state.alertMessage
}
